import Card from "./card.js";
export default class ControlCard extends Card {
  constructor(l, t, s, i, n, r) {
    super(l, t, null, null, null, null, s, null, i, null, null, null, n, r),
      (this.isControl = !0),
      (this.oe = "ab-control-card"),
      (this.ae = !1);
  }
  bt() {
    const l = {};
    return (
      (l[Card.es.hs] = Card.cs.ci),
      (l[Card.es.ds] = this.id),
      (l[Card.es.ps] = this.viewed),
      (l[Card.es.xs] = this.updated),
      (l[Card.es.js] = this.expiresAt),
      (l[Card.es.qs] = this.extras),
      (l[Card.es.vs] = this.pinned),
      (l[Card.es.As] = this.test),
      l
    );
  }
}
